import styled from "styled-components";

export function StatusText({ status, text }: { status: number; text: string }) {
  return status ? (
    <SuccessText>{text}</SuccessText>
  ) : (
    <FailText>{text}</FailText>
  );
}

const SuccessText = styled.div`
  color: rgb(19, 203, 117);
  min-width: 52px;
  width: max-content;
  padding: 0 2px;
  background: rgba(19, 203, 117, 0.2);
  border-radius: 2px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  text-align: center;
`;

const FailText = styled.div`
  color: #ff4444;
  min-width: 52px;
  width: max-content;
  padding: 0 2px;
  background: rgba(255, 68, 68, 0.2);
  border-radius: 2px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  text-align: center;
`;
